import { Navigate, Route, Routes } from "react-router-dom";
import { Client } from "./Client/Client";
import { Contracts } from "./Contracts/Contracts";
import { SalesLead } from "./SalesLead/SalesLead";

export const Sales = () => {
  return (
    <Routes>
      <Route path="/leads/*" element={<SalesLead />} />
      <Route index path="/contract/*" element={<Contracts />} />
      <Route index path="/client/*" element={<Client />} />
      <Route path="*" element={<Navigate to="/not-found" replace />} />
    </Routes>
  );
};
